module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.css
// module id = ./src/app/components/header/header.component.css
// module chunks = main